// extracted by mini-css-extract-plugin
export default {"left-item-wrapper":"_1IXnW","leftItemWrapper":"_1IXnW"};